module.exports = __webpack_public_path__ + "static/media/19ESCAP5.8b8eb2ae.jpg";